// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2qw4RZ-SrOhdh35IWPTKF4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/addButton/styles.css
// module id = 1358
// module chunks = 0